function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import arrayEntry from '../fragments/arrayEntry.js';
import requiredImage from '../fragments/requiredImage.js';
import simpleBlockContent from '../fragments/simpleBlockContent.js';
import callToAction from './callToAction.js';
export var schema = defineObject('pictureAndContentSection', {
    variant: {
        title: 'Variant',
        type: 'string',
        options: {
            list: [
                'image-first',
                'image-last'
            ]
        }
    },
    imageType: {
        title: 'Image type',
        type: 'string',
        options: {
            list: [
                'graphic',
                'image-only',
                'wide-image',
                'small-image'
            ]
        }
    },
    imageGraphic: {
        title: 'Image graphic',
        type: 'string',
        options: {
            list: [
                '1',
                '2',
                '3'
            ]
        }
    },
    background: {
        title: 'Background',
        type: 'string',
        options: {
            list: [
                'default',
                'subtle'
            ]
        }
    },
    image: _object_spread({
        title: 'Image'
    }, requiredImage.fragment),
    secondaryImage: {
        title: 'Secondary image',
        description: 'Not used for all graphic variants',
        type: 'image',
        options: requiredImage.fragment.options
    },
    label: {
        title: 'Label',
        type: 'string'
    },
    title: {
        title: 'Title',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    description: _object_spread({
        title: 'Description'
    }, simpleBlockContent.fragment),
    callToActions: {
        title: 'Call to actions',
        type: 'array',
        of: [
            {
                type: 'callToAction'
            }
        ]
    }
}, [
    callToAction.schema.callToAction
]);
var validator = z.object({
    variant: z.enum([
        'image-first',
        'image-last'
    ]),
    imageType: z.enum([
        'graphic',
        'image-only',
        'wide-image',
        'small-image'
    ]),
    imageGraphic: z.enum([
        '1',
        '2',
        '3'
    ]),
    background: z.enum([
        'default',
        'subtle'
    ]),
    image: requiredImage.validator,
    secondaryImage: requiredImage.validator,
    label: z.string(),
    title: z.string(),
    description: simpleBlockContent.validator,
    callToActions: z.array(callToAction.validator.merge(arrayEntry.validator))
}).partial();
schema.pictureAndContentSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=pictureAndContentSection.js.map